import { createContext, useContext } from 'react';
import SkinStyles from 'components/SkinStyles';

interface ColorPrimaryContextType {
  colorPrimary: string;
  setColorPrimary: (color: string) => void;
}

export const ColorPrimaryContext = createContext<ColorPrimaryContextType>({
  colorPrimary: SkinStyles.Default.colorPrimary,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setColorPrimary: () => {},
});

export const useColorPrimary = () => useContext(ColorPrimaryContext);
